import React from "react";
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import Inbound from "views/Inbound";
import Contacts from "views/Contacts";
import Settings from "views/Settings";
import Directory from "views/Directory";
import { useSelector } from "react-redux";

let ps;

function Layout({ children }) {
  const [routes, setRoutes] = React.useState([]);
  const user = new useSelector((state) => state.authReducer?.data);
  const [activeColor, setActiveColor] = React.useState("green");
  const mainPanel = React.useRef();
  const location = useLocation();
  React.useEffect(() => {
    if (user.role === "user") {
      setRoutes([
        {
          path: "/inbound",
          name: "Inbound",
          icon: "nc-icon nc-bank",
          component: <Inbound />,
          layout: "/user",
        },
        {
          path: "/Contacts",
          name: "Contacts",
          icon: "nc-icon nc-mobile",
          component: <Contacts />,
          layout: "/user",
        },
        {
          path: "/Directory",
          name: "Directory",
          icon: "nc-icon nc-book-bookmark",
          component: <Directory />,
          layout: "/user",
        },
        {
          path: "/Settings",
          name: "Settings",
          icon: "nc-icon nc-settings",
          component: <Settings />,
          layout: "/user",
        },
      ]);
    } else if (user.role === "admin") {
      setRoutes([
        {
          path: "/inbound",
          name: "Inbound",
          icon: "nc-icon nc-bank",
          component: <Inbound />,
          layout: "/admin",
        },
        {
          path: "/Contacts",
          name: "Contacts",
          icon: "nc-icon nc-mobile",
          component: <Contacts />,
          layout: "/admin",
        },
        {
          path: "/Directory",
          name: "Directory",
          icon: "nc-icon nc-book-bookmark",
          component: <Directory />,
          layout: "/admin",
        },
        {
          path: "/Settings",
          name: "Settings",
          icon: "nc-icon nc-settings",
          component: <Settings />,
          layout: "/admin",
        },
      ]);
    }
  }, []);

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.body.classList.toggle("perfect-scrollbar-on");
      }
    };
  }, []);

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const handleActiveClick = (color) => {
    setActiveColor(color);
  };
  return (
    <>
      <div className="wrapper">
        <Sidebar routes={routes} bgColor="white" activeColor={activeColor} />
        <div className="main-panel" ref={mainPanel}>
          <DemoNavbar />
          <div>{children}</div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default Layout;
